import React, { useState } from 'react';

function ProjectCard({ project, onOpen }) {
  const [isHovered, setIsHovered] = useState(false);

  const handleKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onOpen?.();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onOpen?.()}
      onKeyDown={handleKey}
      className={`bg-gray-800 p-6 rounded-lg shadow-lg transition-transform duration-200 ${
        isHovered ? 'scale-105' : ''
      } focus:outline-none focus:ring-2 focus:ring-neon`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
      aria-label={`Open project details: ${project.title}`}
    >
      <h3 className="text-xl font-bold mb-2 neon-text">{project.title}</h3>
      <p className="text-gray-300 mb-4">{project.description}</p>
      <p className="text-sm text-neon mb-4">Tech: {project.tech.join(', ')}</p>
      <div className="flex gap-4">
        <a
          href={project.demo}
          className="text-neon underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-neon"
          target="_blank"
          rel="noopener noreferrer"
        >
          Live Demo
        </a>
        <a
          href={project.github}
          className="text-neon underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-neon"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
      </div>
    </div>
  );
}

export default ProjectCard;